import { render } from "./login-headerborder.vue?vue&type=template&id=23b15793"
import script from "./login-headerborder.vue?vue&type=script&lang=js"
export * from "./login-headerborder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__